export const selectOurFriends = state => state.friends.friends;
export const selectSpinnerToggle = state => state.friends.isLoading;
